export const PendoEvents = {
  PAGE_LOADED: 'ccp-page-load',
};
export type PendoEventsType = (typeof PendoEvents)[keyof typeof PendoEvents];

export interface PendoEventProperties {
  [PendoEvents.PAGE_LOADED]: { path: string };
}
